<template>
  <section id="_fot" class="foto_view_area pt-100 pb-100">
    <div class="container">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              <span style="border-top: 5px solid black"> Foto </span>
            </h4>
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              TJSL KAI
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <p style="color: black">Galeri Foto</p>
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div class="row justify-content-center team_active">
        <!-- START LOOPING -->
        <div class="col-lg-12">
          <div class="row justify-content-center team_active">
            <div
              class="single_team mt-40 wow fadeInUp card col-lg-3 col-md-8 col-sm-10 zoom"
              style="margin: 30px; padding-left: 0%; padding-right: 0%"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
              v-for="(foto, index) in photos"
              :key="index"
            >
              <!-- START IMAGE -->
              <div v-if="foto.foto_detail != ''">
                <img
                  style="width: 100%; max-height: 150px; object-fit: cover"
                  :src="getImgUrl(foto.link + foto.foto_detail[0].nama_foto)"
                  @error="onImgError()"
                  @click="showLightbox(foto)"
                  alt="foto"
                />
              </div>
              <div v-else>
                <img
                  style="width: 100%; max-height: 150px; object-fit: cover"
                  :src="foto.link + '/logo_kai_27062022152956.jpg'"
                  alt="foto"
                  @click="showLightbox(foto)"
                />
              </div>
              <!-- END IMAGE -->
              <!-- START KONTEN -->
              <div class="team_content">
                <div
                  style="position: absolute; bottom: 30%; right: 5%; z-index: 1"
                >
                  <div class="btngroup-small">
                    <i
                      id="share_img"
                      class="lni lni-share"
                      aria-hidden="true"
                      title="share"
                      @click="showLightbox(foto)"
                      :key="foto.id"
                      style="
                        background-color: #e7ebef;
                        color: black;
                        cursor: pointer;
                        border-radius: 50px;
                        box-shadow: 0px 0px 0px 0px black;
                        padding: 1em 1em;
                      "
                    ></i>
                  </div>
                </div>
                <p
                  class="two-line-overflow"
                  style="font-size: 15px; font-weight: 600"
                >
                  {{ foto.nama }}
                </p>
                <!-- <p>{{ foto.waktu_buat }}</p> -->
                <p style="font-size: smaller">
                  &nbsp;
                  <span
                    ><i class="lni lni-eye"></i> {{ foto.visitor_count }}</span
                  >
                  &nbsp; &nbsp;
                  <i class="lni lni-files"></i>
                  {{ foto.foto_detail.length }} Attachment Files
                </p>
              </div>
              <!-- END KONTEN -->
            </div>
          </div>

          <div class="centerBlock">
            <paginate
              v-model="page"
              :page-count="pageCount"
              :click-handler="clickCallback"
              :prev-text="'Sebelumnya'"
              :next-text="'Selanjutnya'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :active-class="'myActiveBtn'"
            >
            </paginate>
          </div>

          <!-- END LOOPING -->
        </div>
      </div>
      <!-- END CONTENT -->
    </div>
    <HelloLightbox
      :images="imagesLightBox"
      :caption="captionLightBox"
      :indeksFromParent="index"
      :visible="visible"
      :nama="nama"
      :pembuat="pembuat"
      :waktu_buat="waktu_buat"
      @clicked="closeLightbox"
      @increase="next"
      @decrease="prev"
    />
  </section>
</template>
<script>
import FotoDataService from "../services/FotoDataService";
import Paginate from "vuejs-paginate-next";
import HelloLightbox from "./components/HelloLightbox.vue";
import axios from "axios";

export default {
  name: "fotoView",
  data() {
    return {
      pageCount: 0, //initial page pagination
      dataPerPage: 6, //for limiting per page
      photos: [],
      page: 1,
      imagesLightBox: [], // untuk hello light box
      index: 0,
      visible: false,
      nama: "", // untuk hello light box
      captionLightBox: [], // untuk hello light box
      pembuat: "", // untuk hello light box
      waktu_buat: "", // untuk hello light box
    };
  },
  props: {
    visibleFoto: Boolean,
  },
  components: {
    paginate: Paginate,
    HelloLightbox,
  },
  computed: {
    showFoto: {
      get() {
        return this.visibleFoto;
      },
      set(visibleFoto) {
        this.$emit("openFotoChild", visibleFoto);
      },
    },
  },
  methods: {
    getCountAllphotos() {
      FotoDataService.getAll(0, 999999999999999)
        .then((response) => {
          var length = response.data.data.length;
          var divided = length / this.dataPerPage;
          this.pageCount = Math.ceil(divided);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    clickCallback(pageNum) {
      console.log(pageNum - 1);
      this.retrievephotos(pageNum - 1, this.dataPerPage);
    },

    retrievephotos(offset, limit) {
      FotoDataService.getAll(offset, limit)
        .then((response) => {
          this.photos = response.data.data;
          console.log(this.photos);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // untuk hello light box
    showLightbox(data) {
      this.nama = data.nama;
      this.pembuat = data.pembuat;
      this.waktu_buat = data.waktu_buat;
      this.visible = true;
      this.index = 0;
      for (let i = 0; i < data.foto_detail.length; i++) {
        this.imagesLightBox.push(data.link + data.foto_detail[i].nama_foto);
        this.captionLightBox.push(data.foto_detail[i].caption);
      }

      //insert visitor saat klik light box
      this.getUserAgent(data.id);
    },
    // untuk hello light box
    closeLightbox() {
      this.visible = false;
      this.index = 0;
      this.imagesLightBox = [];
      this.captionLightBox = [];
    },

    prev(n) {
      this.index -= n;
    },

    next(n) {
      this.index += n;
    },
    getImgUrl: function (imagePath) {
      return imagePath;
    },
    onImgError() {
      this.imgError = true;
    },
    retrieveFotos() {
      FotoDataService.getAll(0, 3)
        .then((response) => {
          this.photos = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getUserAgent(gf_id) {
      axios.get("https://geolocation-db.com/json/").then((response) => {
        FotoDataService.sendUserAgent(
          gf_id,
          "foto",
          response.data.country_name,
          response.data.country_code,
          response.data.city,
          response.data.state,
          response.data.latitude,
          response.data.longitude,
          response.data.IPv4
        )
          .then((response) => {
            console.log(response.data);
            // this.currentArtikel = this.artikels[0];
            // this.currentIndex = 0;
          })
          .catch((e) => {
            console.log(e);
          });
        // this.products = response.data.products;
        // console.log(response.data.country_name);
      });
    },
  },
  mounted() {
    this.getCountAllphotos();
    this.retrievephotos(0, this.dataPerPage);
  },
};
</script>

<style>
.zoom {
  transition: transform 0.2s; /* Animation */
}
.zoom:hover {
  transform: scale(1.04);
  cursor: pointer;
}
.two-line-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
}
</style>
